import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext } from "react-hook-form";
import AdHocFilterSelectField from "./AdHocFilterSelectField";
/**
 * Reusable wrapper for AdHocFilterSelectField that enforces population selection.
 *
 * Originally created for PipelineForm, now shared across:
 * - PipelineForm (opportunity.populationAdHocCaseloads)
 * - CampaignFormMessageSettings (populationAdHocCaseloads)
 *
 * This component prevents users from selecting a caseload without first selecting
 * a population/filter, providing visual feedback and auto-clearing functionality.
 */
const AdHocCaseloadField = ({ name, population }) => {
    const { setValue, watch } = useFormContext();
    const isDisabled = !(population === null || population === void 0 ? void 0 : population.id);
    const caseloadValue = watch(name);
    // Clear caseload value when population is removed
    React.useEffect(() => {
        if (isDisabled && caseloadValue && caseloadValue.length > 0) {
            setValue(name, []);
        }
    }, [isDisabled, caseloadValue, setValue, name]);
    return (_jsxs("div", { children: [_jsx("div", { style: { opacity: isDisabled ? 0.6 : 1 }, children: _jsx("div", { style: { pointerEvents: isDisabled ? "none" : "auto" }, children: _jsx(AdHocFilterSelectField, { name: name }) }) }), isDisabled && (_jsxs("small", { className: "text-muted d-block mt-1", children: [_jsx("i", { className: "fa fa-info-circle mr-1" }), "Select a filter above before limiting to your caseload"] }))] }));
};
export default AdHocCaseloadField;
